import {Component, Input, OnInit} from '@angular/core';
import {ClsUtil} from '../../../../util/cls-util';
import {TranslateModule} from '@ngx-translate/core';
import { IgxButtonDirective, IgxButtonModule, IgxRippleDirective, IgxRippleModule } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';

@Component({
  selector: 'app-btn-url-contenido',
  templateUrl: './btn-url-contenido.component.html',
  styleUrls: ['./btn-url-contenido.component.scss'],
  imports: [
    IgxRippleModule,
    IgxRippleDirective,
    TranslateModule,
    IgxIconComponent,
    IgxButtonModule,
    IgxButtonDirective,
  ]
})
export class BtnUrlContenidoComponent implements OnInit {
  @Input()
  public valor: string;
  @Input()
  public archivoValido = true;

  constructor() {
  }

  ngOnInit(): void {
  }

  public activarBoton(): boolean {
    if (this.archivoValido && ClsUtil.esNulo(this.valor)) {
      return false;
    }
    return !(this.archivoValido && this.valor.length === 0);
  }

  public verContenido(url: string) {
    if (this.archivoValido) {
      ClsUtil.vistaPrevia(url);
    }
  }

}
